import { render, staticRenderFns } from "./ContractDownloadButton.vue?vue&type=template&id=ed6f4098&"
import script from "./ContractDownloadButton.vue?vue&type=script&lang=js&"
export * from "./ContractDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports